Vendd.Scripts.load(function () {

    var $wrapper = $('.side-menu');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    wrapper.open = function () {
        $('.mobile-title', $wrapper).addClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass('icon-arrow-down').addClass('icon-arrow-up');
        $('.nav-1', $wrapper).addClass('active');
    };

    wrapper.close = function () {
        $('.mobile-title', $wrapper).removeClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $('.nav-1', $wrapper).removeClass('active');
    };

    if ($wrapper.hasClass('x-account-menu')) {
        $wrapper.on('click', '.js-logout', function (e) {
            e.preventDefault();
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
        });
    }
    
    $wrapper.on('click', '.mobile-title', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('active')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            wrapper.close();
        }
    });
});

